const SafetyIconEstateCar = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M10.3744 19.6035C8.70263 19.6035 8.70399 22.1995 10.3744 22.1995C12.0499 22.1995 12.0512 19.6035 10.3744 19.6035ZM10.3744 21.2965C9.86834 21.2965 9.86699 20.5065 10.3744 20.5065C10.8869 20.5065 10.886 21.2965 10.3744 21.2965Z"
      fill="#171717"
    />
    <path
      d="M27.3051 19.6035C25.6333 19.6035 25.6347 22.1995 27.3051 22.1995C28.9805 22.1995 28.9819 19.6035 27.3051 19.6035ZM27.3051 21.2965C26.799 21.2965 26.7976 20.5065 27.3051 20.5065C27.8175 20.5065 27.8166 21.2965 27.3051 21.2965Z"
      fill="#171717"
    />
    <path
      d="M31.991 21.6542C31.9846 21.145 31.9268 18.7219 31.358 16.5539C30.8401 14.5841 28.1882 12.8311 26.4608 12.8311H22.2093H17.9957C15.9862 12.8311 11.6538 14.6776 10.8899 16.2212C9.36306 16.2555 4 16.5638 4 19.2063V21.7477C4 21.9969 4.20181 22.1991 4.45147 22.1991H7.69938C8.75628 24.4014 12.0033 24.4145 13.0552 22.1991H24.6297C25.6866 24.4014 28.9336 24.4145 29.9855 22.1991H31.5399C31.5435 22.1996 31.5472 22.1991 31.549 22.1991C31.8325 22.1991 32.0474 21.931 31.991 21.6542C31.9973 21.6845 31.9846 21.145 31.991 21.6542ZM30.2559 16.2171H26.9123V13.7868C28.0175 14.022 29.6054 15.018 30.2559 16.2171ZM26.0094 16.2171H22.6608V13.734H26.0094V16.2171ZM21.7578 16.2171H18.4472V13.734H21.7578V16.2171ZM17.5442 13.7593V16.2171H11.9992C12.9202 15.3733 15.6097 13.9647 17.5442 13.7593ZM10.3793 22.9892C9.53101 22.9892 8.75448 22.4624 8.44206 21.6641C8.43528 21.6497 8.42896 21.6357 8.41181 21.5838C7.89667 20.2555 8.99782 18.8131 10.3793 18.8131C11.8019 18.8131 12.8394 20.2831 12.3297 21.6213C12.0827 22.4366 11.2051 22.9892 10.3793 22.9892ZM27.3096 22.9892C26.4613 22.9892 25.6848 22.4624 25.3723 21.6641C25.3656 21.6497 25.3592 21.6357 25.3421 21.5838C24.827 20.2555 25.9281 18.8131 27.3096 18.8131C28.7322 18.8131 29.7697 20.2831 29.26 21.6213C29.013 22.4366 28.1354 22.9892 27.3096 22.9892ZM30.2717 21.2962C30.5124 19.5314 29.0871 17.9101 27.3092 17.9101C25.5313 17.9101 24.1019 19.5291 24.3425 21.2962H13.3415C13.5821 19.5314 12.1568 17.9101 10.3789 17.9101C8.60097 17.9101 7.17161 19.5291 7.41224 21.2962H4.90295V20.5061H6.1445C6.7269 20.5061 6.7269 19.6032 6.1445 19.6032H4.90295V19.2063C4.90295 17.5052 9.58383 17.1205 11.2236 17.1201H17.9957H22.2093H26.4608H30.5684C30.9494 18.7449 31.051 20.4921 31.0785 21.2962H30.2717Z"
      fill="#171717"
    />
    <path
      d="M17.7509 17.9102H16.0579C15.4755 17.9102 15.4755 18.8131 16.0579 18.8131H17.7509C18.3333 18.8131 18.3333 17.9102 17.7509 17.9102Z"
      fill="#171717"
    />
  </svg>
)

export default SafetyIconEstateCar
